//	@flow

export const SET_MY_SPACES_SCREEN = 'SET_MY_SPACES_SCREEN';
